module.exports = __webpack_public_path__ + "static/media/calendar.aea6a773.svg";